import { clsx } from 'clsx';
import * as s from './progressBar.css';

type ProgressBarProps = {
  /** 0 to 1. Values outside are clamped. */
  value: number;
  color?: 'primary' | 'success';
  /** Accessible name, e.g. the funnel row label. */
  ariaLabel?: string;
  className?: string;
  testId?: string;
};

export const ProgressBar = ({
  value,
  color = 'primary',
  ariaLabel,
  className,
  testId = 'progress-bar',
}: ProgressBarProps) => {
  const clamped = Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0;
  return (
    <div
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped * 100)}
      className={clsx(s.track, className)}
      data-testid={testId}
    >
      <div
        className={s.fill({ color })}
        style={{ width: `${clamped * 100}%` }}
      />
    </div>
  );
};
